export { default as RulersSolidIcon } from './RulersSolidIcon';
